<template>
  <va-form :id="id" :item="item">
    <v-row justify="center">
      <v-col lg="8">
        <va-text-input source="name" />
        <va-text-input source="description" />
        <va-array-input source="characteristics" v-slot="props">
          <v-row>
            <v-col sm="12">
              <va-select-input v-bind="props" :choices="types" source="type" />
              <v-col sm="6">
                <va-text-input v-bind="props" source="value" />
              </v-col>
            </v-col>
          </v-row>
        </va-array-input>
        <va-array-input source="images" v-slot="props">
          <v-row>
            <v-col sm="12">
              <va-file-input
                v-bind="props"
                :label="$t('Image')"
                source="images"
                required
              />
            </v-col>
          </v-row>
        </va-array-input>
        <va-save-button></va-save-button>
      </v-col>
    </v-row>
  </va-form>
</template>

<script>
export default {
  props: ["id", "title", "item"],
  data() {
    return {
      types: [
        { value: "color", text: "Color" },
        { value: "size", text: "Size" },
        { value: "gender", text: "Gender" },
        { value: "category", text: "Category" },
      ],
    };
  },
};
</script>
